import { FlexBox } from "components/Common/FlexBox"
import styled from "styled-components"
import { IProfileGender } from "../profileTypes"

const GenderItem = styled.div<{ $active: boolean }>`
  padding: 15px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: ${(props) => (props.$active ? "#2CCCD3" : "#fff")};
  background: ${(props) => (props.$active ? "#ffffff1a" : "#ffffff0d")};
  font-weight: ${(props) => (props.$active ? "700" : "400")};
  backdrop-filter: blur(60px);
  flex: 1 1 0;
`

const LeftGenderItem = styled(GenderItem)`
  border-radius: 8px 0px 0px 8px;
`

const RightGenderItem = styled(GenderItem)`
  border-radius: 0px 8px 8px 0px;
`

const GenderSelection = ({
  value,
  onChange,
}: {
  value?: IProfileGender
  onChange: (gender: IProfileGender) => void
}) => {
  return (
    <FlexBox $justify="space-between" $gap={8}>
      <LeftGenderItem
        $active={value === "MALE"}
        onClick={() => {
          onChange("MALE")
        }}
      >
        Male
      </LeftGenderItem>
      <GenderItem
        onClick={() => {
          onChange("FEMALE")
        }}
        $active={value === "FEMALE"}
      >
        Female
      </GenderItem>
      <RightGenderItem
        onClick={() => {
          onChange("NON_BINARY")
        }}
        $active={value === "NON_BINARY"}
      >
        Non-Binary
      </RightGenderItem>
    </FlexBox>
  )
}

export default GenderSelection
